import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nav-items-group',
  templateUrl: './nav-items-group.component.html',
  styleUrls: ['./nav-items-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemsGroupComponent {}
